const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_TIMECARDS':
      return action.timecards;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/timecards.js